import { FormField as ChordsFormField } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormField = withClassNameHoc(ChordsFormField);
